import React from 'react';
import ProgressBarContext from "./ProgressBarContext";
var ProgressBarProvider = function ProgressBarProvider(_ref) {
  var completion = _ref.completion,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(ProgressBarContext.Provider, {
    value: {
      completion: completion
    }
  }, children);
};
export default ProgressBarProvider;